import React from 'react'
import styles from './NotFound.module.css'
export default function NotFound() {
  
  return <>
      <div className="d-flex justify-content-center align-items-center m-5" >
      <div>
        <img src={require('../../assets/images/error.svg').default} alt="Error" className="img-fluid" />
      </div>
    </div>
    
    </>
  
}
